import { render, staticRenderFns } from "./ItemWriteMyItemLayout.vue?vue&type=template&id=04bcc092&scoped=true&"
import script from "./ItemWriteMyItemLayout.vue?vue&type=script&lang=js&"
export * from "./ItemWriteMyItemLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcc092",
  null
  
)

export default component.exports